'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Actions = require('../../../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _CartItems = require('../CartItems.jsx');

var _CartItems2 = _interopRequireDefault(_CartItems);

var _MainStore = require('../../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _reflux = require('reflux');

var _reflux2 = _interopRequireDefault(_reflux);

var _Utility = require('../../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _UtensilsAndNapkinsView = require('./UtensilsAndNapkinsView.jsx');

var _UtensilsAndNapkinsView2 = _interopRequireDefault(_UtensilsAndNapkinsView);

var _CartStore = require('../../../stores/CartStore');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _Constants = require('../../Constants');

var Constants = _interopRequireWildcard(_Constants);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CartUtensilsAndNapkins = (0, _createReactClass2.default)({
    displayName: 'CartUtensilsAndNapkins',
    getInitialState: function getInitialState() {
        return {
            orderInstruction: "",
            errors: "",
            orderType: ""
        };
    },
    UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
        var self = this;
        var orderType = _CartStore2.default.getOrderType();

        self.setState({
            orderType: orderType,
            orderInstruction: _CartStore2.default.getOrderInstructions()
        });
    },
    UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps) {
            this.setState({
                orderType: _CartStore2.default.getOrderType(),
                orderInstruction: _CartStore2.default.getOrderInstructions()
            });
        }
    },
    isUtensilsAndNapkins: function isUtensilsAndNapkins() {
        var isUtensils = _MainStore2.default.isLocUtensilsAndNapkinsEnabled();
        if (isUtensils && !(this.state.orderType == Constants.DINEIN)) {
            return true;
        } else {
            return false;
        }
    },
    onTotalOrderInstChanged: function onTotalOrderInstChanged(e) {
        this.setState({
            orderInstruction: e.target.value
        });
        _Actions2.default.addOrderInstructions(e.target.value);
    },
    loadCartItemsStructure: function loadCartItemsStructure() {
        return _react2.default.createElement(
            'div',
            { className: 'cart_order' },
            _react2.default.createElement(
                'div',
                { className: 'cart-heading f16-default mb-10 border-bottom' },
                'Order Items'
            ),
            _react2.default.createElement(_CartItems2.default, {
                isMobile: this.props.isMobile
            })
        );
    },
    loadUtensilsNapkinsStructure: function loadUtensilsNapkinsStructure() {

        if (this.isUtensilsAndNapkins()) {
            return _react2.default.createElement(_UtensilsAndNapkinsView2.default, null);
        } else {
            return null;
        }
    },
    render: function render() {

        return _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                'div',
                null,
                this.props.isMobile ? _react2.default.createElement(
                    'div',
                    { className: "bg-white rounded shadow-sm p-4 mb-4" },
                    this.loadCartItemsStructure()
                ) : null,
                _react2.default.createElement(
                    'div',
                    { className: "bg-white rounded shadow-sm p-4 mb-3" },
                    !Utils.isEmpty(this.props.errors["utensilsError"]) ? _react2.default.createElement(
                        'div',
                        { className: 'alert alert-danger mt-10 ft-14', role: 'alert' },
                        _react2.default.createElement(
                            'i',
                            { className: 'material-icons mr-1 ft-20' },
                            'report'
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'sr-only' },
                            'Error:'
                        ),
                        _react2.default.createElement(
                            'b',
                            { className: "err-box" },
                            this.props.errors["utensilsError"]
                        )
                    ) : null,
                    this.loadUtensilsNapkinsStructure(),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-row mb-0' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group col-md-12' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'total_order_inst', className: 'cart-heading f16-default' },
                                'Add Order Instructions'
                            ),
                            _react2.default.createElement('input', {
                                type: 'text',
                                id: 'total_order_inst',
                                name: 'total_order_inst',
                                className: 'form-control',
                                placeholder: 'Enter Any Order Instructions'
                                // title="Enter any order instructions"
                                , onChange: this.onTotalOrderInstChanged,
                                value: this.state.orderInstruction,
                                tabIndex: 14
                            })
                        )
                    )
                )
            ),
            _react2.default.createElement('div', { className: 'pt-2' })
        );
    }
});

exports.default = CartUtensilsAndNapkins;


//////////////////
// WEBPACK FOOTER
// ./src/components/cart-view/cart-left/CartUtensilsAndNapkins.jsx
// module id = 716
// module chunks = 0